import React from 'react';

interface LaunchSectionProps {
  enrolledCount?: number;
  loading?: boolean;
  maxSlots?: number;
  onLaunch?: () => void;
  hasSubscription?: boolean;
}

export const LaunchSection: React.FC<LaunchSectionProps> = ({
  enrolledCount = 0,
  loading = false,
  maxSlots = 0,
  onLaunch,
  hasSubscription = false
}) => {
  const enrolled = enrolledCount < maxSlots ? enrolledCount : maxSlots;  
  const remainingSlots = maxSlots - enrolled;
  const progressPercentage = (enrolled / maxSlots) * 100;
  const canLaunch = remainingSlots > 0 && hasSubscription;

  return (
    <div className="w-80 h-auto relative">
      <div className="w-full h-full bg-white rounded-2xl shadow-sm border border-gray-200">
        <div className="p-4">
          <div className="flex justify-between items-start mb-2">
            <div className="text-black text-sm font-normal">
              Skillstree Pathways Enrolled:
            </div>
            {loading ? (
              <div className="animate-pulse bg-gray-700/70 rounded h-6 w-12 mx-auto"></div>
            ) : (
              <div className="text-black text-sm font-normal">
                {enrolled}/{maxSlots}
              </div>
            )}
          </div>
          
          <div className="w-full bg-gray-200 rounded-full h-1.5 mb-2">            
            {loading ? (
              <div className="animate-pulse h-1.5 bg-gray-700/70 rounded"></div>
            ) : (
              <div 
                className="bg-blue-500 h-1.5 rounded-full transition-all duration-300"
                style={{ width: `${progressPercentage || 1}%` }}
              />
            )}
          </div>
          {loading ? (
            <div className="animate-pulse bg-gray-700/70 rounded h-6 w-full mb-4"></div>
          ) : (
            <div className="text-red-600 text-sm font-normal mb-4 text-start">
              {remainingSlots} active slots remaining
            </div>
          )}
          
          <button
            disabled={!canLaunch}
            onClick={onLaunch}
            className={`cursor-pointer w-full ${canLaunch ? 'bg-orange-600 hover:bg-orange-700' : 'bg-gray-600 hover:bg-gray-700'} text-white py-2 px-4 rounded-md transition-colors duration-200 font-medium text-base leading-6 text-center`}
          >
            Launch My Skillstree
          </button>
        </div>
      </div>
    </div>
  );
};